
















































































































































































































import { Vue } from 'vue-property-decorator';
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';
import { NOC, IMaterial } from '@/class/common/const' ;
import util from '@/components/util';
// import BasicGadget, {VUECHARTGRAPH, IGraph, CFrame} from '@/components/gadgets/BasicGadget.vue';
import BasicGadget, {VUECHARTGRAPH, IGraph, CFrame} from '@/components/gadgets/EditerBasicGadgetV3.vue';
// import MaterialsList from '@/parts/graph/MaterialsList.vue';
import MaterialsListV3 from '@/parts/graph/MaterialsListV3.vue';
import MaterialHelpModal from '@/parts/graph/MaterialHelpModal.vue';
import GraphTooltip from '@/parts/graph/GraphTooltip.vue';
import ModalInputBase from '@/components/util/ModalInputBase.vue';

import * as models from '@/class/models/views/graph';
import { INavigation } from '@/class/models/views/dashboard';
import API from '@/api/common';
import VariableInput, {IVariableInput, INPUT_TYPE} from '@/components/util/VariableInput.vue';
import * as validation from '@/personal/validation';
import { IFrame as ifr, IFrameEdit } from '@/components/gadgets/GadgetFrame.vue';

export type IFrame = ifr;

// lintエラー解消用
interface Data {
  gadgets: models.IGadget[];
  sideModal: boolean;
  editGadget: models.CGadget;
  editValues: models.CValues;
  materialsView: models.IDomain[];
  selectGraphClass: string;
  frameData: CFrame;
  items: IVariableInput[];
  detailModal: boolean;
  editOptions: {};
  tooltip: models.ITooltip;
  helpmodal: string;
  showCompareItems: boolean;
  isButtonDisabled: boolean;
  addDashboardConfirmModal: boolean;
}
interface Methods {
  frameDataEdit: (frameData: any) => void;
  setOptions: (data: any) => void;
  setValues: (data: models.IValues) => void;
  setGadget: (gadget: any) => void;
  setTooltip: (data: models.ITooltip) => void;
  onScroll: () => void;
  onClickGadgetList: () => void;
  onClickGraphCarousel: (increment: number) => void;
  onClickSelectGraphIcon: (graph: IGraph) => void;
  onClickMaterials: (selectValue: models.IDomain) => void;
  transformMaterials: (materials: models.IDomain[], isInverse?: boolean) => models.IDomain[];
  classGraphIcon: (value: any) => { selected: boolean, darken: boolean };
  onClickRegistGraph: () => Promise<void>;
  addToDashboard: () => void;
  backToAddGadgets: () => void;
  onClickDelteGraph: () => Promise<void>;
  showDetail: (values: models.IValues) => void;
  returnSetting: (key: string) => any;
}
interface Computed {
  MATERIAL_TYPE: IMaterial[];
  MATERIAL_TARGET: IMaterial[];
  MATERIAL_MEASURE: IMaterial[];
  MATERIAL_DIMENSION: IMaterial[];
  MATERIAL_COMPARE_TYPE: IMaterial[];
  MATERIAL_COMPARE_TARGET: IMaterial[];
  MATERIAL_COMPARE_MEASURE: IMaterial[];
  GRAPHS: IGraph[];
  EDIT: boolean;
  SELECTED_GRAPH: string;
  IS_SELECTED_TYPE: boolean;
  IS_SELECTED_TARGET: boolean;
  IS_SELECTED_MEASURE: boolean;
  IS_SELECTED_DIMENSION: boolean;
  IS_ABLE_TO_COMPARE: boolean;
  MATRIX_SINGLE: ITransMatrix[];
  MATRIX_MULTI: ITransMatrix[];
}
interface Props {
  indexs: [];
  selectGadget: object;
  confirmDialog: (message: string) => Promise<any>;
  addGadgetLock: (addNum?: number) => boolean;
  navigation: INavigation;
}
interface ITransMatrix {
  view: IMaterial;
  actual: IMaterial[];
}

export default Vue.extend({
  name: 'GadgetEditer3',
  components: {
    ...util,
    BasicGadget,
    MaterialsListV3,
    MaterialHelpModal,
    GraphTooltip,
    ModalInputBase,
    VariableInput,
  },
  props: {
    indexs: Array,
    selectGadget: Object,
    confirmDialog: Function,
    addGadgetLock: Function,
    navigation: Object,
  },
  computed: {
    MATERIAL_TYPE() {
      return NOC.MATERIAL.V3.MATERIALS_BETA.filter((v) => (v.domain === NOC.MATERIAL.V3.DOMAIN.TYPE));
    },
    MATERIAL_TARGET() {
      return NOC.MATERIAL.V3.MATERIALS_BETA.filter((v) => (v.domain === NOC.MATERIAL.V3.DOMAIN.TARGET));
    },
    MATERIAL_MEASURE() {
      return NOC.MATERIAL.V3.MATERIALS_BETA.filter((v) => (v.domain === NOC.MATERIAL.V3.DOMAIN.MEASURE));
    },
    MATERIAL_DIMENSION() {
      return NOC.MATERIAL.V3.MATERIALS_BETA.filter((v) => (v.domain === NOC.MATERIAL.V3.DOMAIN.DIMENSION));
    },
    MATERIAL_COMPARE_TYPE() {
      return NOC.MATERIAL.V3.MATERIALS_BETA.filter((v) => (v.domain === NOC.MATERIAL.V3.DOMAIN.COMPARE_TYPE));
    },
    MATERIAL_COMPARE_TARGET() {
      return NOC.MATERIAL.V3.MATERIALS_BETA.filter((v) => (v.domain === NOC.MATERIAL.V3.DOMAIN.COMPARE_TARGET));
    },
    MATERIAL_COMPARE_MEASURE() {
      return NOC.MATERIAL.V3.MATERIALS_BETA.filter((v) => (v.domain === NOC.MATERIAL.V3.DOMAIN.COMPARE_MEASURE));
    },
    GRAPHS() {
      return VUECHARTGRAPH;
    },
    EDIT() {
      return true;
    },
    SELECTED_GRAPH() {
      const selectedGraphObj = this.GRAPHS.find((v: any) => (v.key === this.selectGraphClass));
      return selectedGraphObj ? selectedGraphObj.lable : '';
    },
    IS_SELECTED_TYPE() {
      return NOC.MATERIAL.V3.getType(this.materialsView) ? true : false;
    },
    IS_SELECTED_TARGET() {
      return NOC.MATERIAL.V3.getTargets(this.materialsView).length > 0;
    },
    IS_SELECTED_MEASURE() {
      return NOC.MATERIAL.V3.getMeasures(this.materialsView).length > 0;
    },
    IS_SELECTED_DIMENSION() {
      return NOC.MATERIAL.V3.getDimensions(this.materialsView).length > 0;
    },
    IS_ABLE_TO_COMPARE() {
      return this.IS_SELECTED_TYPE && this.IS_SELECTED_TARGET && this.IS_SELECTED_MEASURE &&
        this.IS_SELECTED_DIMENSION && this.SELECTED_GRAPH.length &&
        this.selectGraphClass !== NOC.CHARTS.HORIZONTALBAR &&
        this.selectGraphClass !== NOC.CHARTS.STACKED_HORIZONTALBAR;
    },
    MATRIX_SINGLE() {
      return [
        { view: NOC.MATERIAL.V3.MATERIAL_BETA.DIMENSION_YEAR,  actual: [ NOC.MATERIAL.V3.MATERIAL.DIMENSION_YEAR ] },
        { view: NOC.MATERIAL.V3.MATERIAL_BETA.DIMENSION_MONTH, actual: [ NOC.MATERIAL.V3.MATERIAL.DIMENSION_MONTH, NOC.MATERIAL.V3.MATERIAL.TARGET_YEAR ] },
        { view: NOC.MATERIAL.V3.MATERIAL_BETA.DIMENSION_DATE,  actual: [ NOC.MATERIAL.V3.MATERIAL.DIMENSION_DATE, NOC.MATERIAL.V3.MATERIAL.TARGET_MONTH ] },
        { view: NOC.MATERIAL.V3.MATERIAL_BETA.DIMENSION_HOUR,  actual: [ NOC.MATERIAL.V3.MATERIAL.DIMENSION_HOUR, NOC.MATERIAL.V3.MATERIAL.TARGET_DATE ] },
      ];
    },
    MATRIX_MULTI() {
      return [
        { view: NOC.MATERIAL.V3.MATERIAL_BETA.DIMENSION_YEAR, actual: [ NOC.MATERIAL.V3.MATERIAL.TARGET_YEAR ] },
        { view: NOC.MATERIAL.V3.MATERIAL_BETA.DIMENSION_MONTH, actual: [ NOC.MATERIAL.V3.MATERIAL.TARGET_MONTH ] },
        { view: NOC.MATERIAL.V3.MATERIAL_BETA.DIMENSION_DATE, actual: [ NOC.MATERIAL.V3.MATERIAL.TARGET_DATE ] },
        { view: NOC.MATERIAL.V3.MATERIAL_BETA.DIMENSION_HOUR, actual: [] },
      ];
    },
  },
  data() {
    return {
      gadgets : [] as models.IGadget[],
      sideModal: false,
      editGadget: new models.CGadget(),
      editValues: new models.CValues(),
      materialsView: [] as models.IDomain[],
      selectGraphClass: '',
      frameData: new CFrame(),
      items: [
        {key: 'title', name: 'グラフタイトル', type: INPUT_TYPE.TEXT, placeholder: 'タイトルを入力してください', required: false, checks: [], error: '', max: 20},
        {key: 'comment', name: 'メモ', type: INPUT_TYPE.TEXTAREA, placeholder: '200文字以内', required: false, checks: [], error: '', max: 200},
      ] as IVariableInput[],
      detailModal: false,
      editOptions: {},
      tooltip: {} as models.ITooltip,
      helpmodal: '',
      showCompareItems: false,
      isButtonDisabled: false,
      addDashboardConfirmModal: false,
    };
  },
  created() {
    window.addEventListener('scroll', this.onScroll);
    // frame設定
    this.frameData.edit = true;
    this.frameData.options = true;
    // Dashboardから編集
    if ((this.selectGadget as any).gadgetID) {
      const editGadget = this.selectGadget as unknown as any;
      this.materialsView = this.transformMaterials(editGadget.data.materials, true);
      this.setGadget(editGadget);
      // 廃止項目（就業未達時間など）の削除を反映
      this.editGadget.data.materials = this.transformMaterials(this.materialsView);
      // this.onEdit(editGaget);
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this.onScroll);
  },
  async mounted() {
    // console.log('moutend')
    this.$emit('pushPath', this.$route.path);
    this.editGadget.gadget = 'BasicGadgetV3';

    /*
    // データ取得
    const api = new API();
    const res = await api.get<models.VGraph>('graph');
    // console.log(res);
    if (res.result) {
      this.gadgets = res.data.gadgets;
    }
    */
  },
  methods: {
    frameDataEdit(frameData: any) {
      this.editGadget.title = frameData.title;
      this.editGadget.comment = frameData.comment;
    },
    setOptions(data: any) {
      this.editOptions = data;
      // console.log('this.editOptions', this.editOptions);
    },
    setValues(data: any) {
      const values = data[1];
      this.editValues.setData = values.setData;
      this.editValues.date = values.date;
      this.frameData.detail = false;
      if (values.setData.length > 0 && values.date && values.date.length >= 10 && values.setData !== '0') {
        this.frameData.detail = true;
      }
      if (values.compareSetData && values.compareSetData !== '0') {
        // 比較対象が設定された場合、ナビゲーションをOFFにする
        this.$emit('closeNavi', 'compareNavi');
      }
    },
    setGadget(gadget: any) {
      this.selectGraphClass = gadget.data.graph[0].key;
      this.sideModal = false;
      this.editGadget = gadget;
      this.showCompareItems = this.IS_ABLE_TO_COMPARE && this.editGadget.data.materials.some((v) =>
        v.domain === NOC.MATERIAL.V3.DOMAIN.COMPARE_TYPE ||
        v.domain === NOC.MATERIAL.V3.DOMAIN.COMPARE_TARGET ||
        v.domain === NOC.MATERIAL.V3.DOMAIN.COMPARE_MEASURE);
      if (!this.GRAPHS.some((v) => v.key === this.selectGraphClass)) {
        // 廃止グラフ（レーダーチャート、円グラフ）の場合はグラフ選択なしとする
        this.selectGraphClass = '';
        this.editGadget.data.graph = [];
      }
    },
    setTooltip(data: models.ITooltip) {
      this.tooltip = JSON.parse(JSON.stringify(data));
    },
    onScroll() {
      // スクロールしたらグラフツールチップを非表示にする
      if (this.tooltip.tooltipModel) {
        this.tooltip.tooltipModel.opacity = 0;
      }
    },
    onClickGadgetList() {
      this.sideModal = !this.sideModal;
    },
    onClickGraphCarousel(increment: number) { // 1 | -1
      const selectedGraphIdx = this.GRAPHS.findIndex((v: any) => (v.key === this.selectGraphClass));
      let afterIdx = selectedGraphIdx;
      for (let i = 0; i < this.GRAPHS.length; i++) {
        afterIdx += increment;
        if (afterIdx < 0) {
          afterIdx = this.GRAPHS.length - 1;
        } else if (this.GRAPHS.length <= afterIdx) {
          afterIdx = 0;
        }
        const graphClass = this.classGraphIcon(this.GRAPHS[afterIdx].key);
        if (!graphClass.darken) { // 非活性のグラフ項目はスキップ
          break;
        }
      }
      this.onClickSelectGraphIcon(this.GRAPHS[afterIdx]);
    },
    // グラフ要素選択時イベント
    onClickSelectGraphIcon(graph: IGraph) {
      const result = this.editGadget.data.graph.find((v) => (v.key === graph.key));
      if (!result) {
        const newGraph = new models.CDomain();
        newGraph.key = graph.key;
        this.selectGraphClass = graph.key;
        this.editGadget.data.graph = [newGraph];
      } else {
        this.selectGraphClass = '';
        this.editGadget.data.graph = [];
      }
      // this.gadgetData.data.graph = this.selectGraph;
    },
    // 要素選択処理
    onClickMaterials(selectValue: models.IDomain) {
      if (!this.materialsView.some((v) => v.id === selectValue.id)) {
        if (this.materialsView.length > 0) {
          this.materialsView = this.materialsView
            .filter((v) =>
            (selectValue.reject.indexOf(v.id) === -1 && v.id !== selectValue.id));
        }
        this.materialsView.push(selectValue);

        // グラフ項目が非活性の場合は選択を外す
        const graphClass = this.classGraphIcon(this.selectGraphClass);
        if (graphClass.darken) {
          this.selectGraphClass = '';
          this.editGadget.data.graph = [];
        }
      } else {
        this.materialsView = this.materialsView
          .filter((v: models.IDomain) => (selectValue.id !==  v.id));
      }
      // 新旧デザインの対応付け
      this.editGadget.data.materials = this.transformMaterials(this.materialsView);
      // console.log(this.gadgetData.data.materials);
      // console.log(this.gadgetData);
      // this.gadgetData.data.materials = this.gadgetData.data.materials;
    },

    // materials変換
    // inInverse：trueならダッシュボードから編集、falseならグラフ作成画面でmaterial選択
    transformMaterials(materials: models.IDomain[], isInverse?: boolean): models.IDomain[] {
      let newMaterials: models.IDomain[] = [];

      /* type */
      const type = NOC.MATERIAL.V3.getType(materials);
      if (type) {
        newMaterials.push(type);
      } else {
        if (isInverse) {
          newMaterials.push(NOC.MATERIAL.V3.MATERIAL.TYPE_SUM);
        }
      }

      /* measure */
      const measures = NOC.MATERIAL.V3.getMeasures(materials);
      if (!isInverse) {
        newMaterials = newMaterials.concat(measures);
      } else {
        for (const measure of measures) {
          switch (measure.id) {
            case NOC.MATERIAL.V3.MATERIAL.MEASURE_WARKING_TIME.id: // 勤務時間 <-> 実労働時間
              newMaterials.push(NOC.MATERIAL.V3.MATERIAL_BETA.MEASURE_WARKING_TIME);
              break;
            case NOC.MATERIAL.V3.MATERIAL.MEASURE_SETTING_TIME.id: // 旧就業時間：非表示
            // case NOC.MATERIAL.V3.MATERIAL.MEASURE_UNACHIEVED_TIME.id: // 就業未達成時間：非表示
              break;
            default:
              newMaterials.push(measure);
              break;
          }
        }
      }

      /* compare */
      const compares = materials.filter((v) => (
        v.domain === NOC.MATERIAL.V3.DOMAIN.COMPARE_TYPE
        || v.domain === NOC.MATERIAL.V3.DOMAIN.COMPARE_TARGET
        || v.domain === NOC.MATERIAL.V3.DOMAIN.COMPARE_MEASURE
      ));
      newMaterials = newMaterials.concat(compares);

      // 個人・グループの場合
      // 年 -> 選択無し・年毎
      // 月 -> 年・月毎
      // 日 -> 月・日毎
      // 時 -> 日・時毎
      let matrix;
      if (!isInverse) {
        if (materials.some((v) => (v.id === NOC.MATERIAL.V3.MATERIAL_BETA.TARGET_MEMBER.id))) {
          // 個人
          newMaterials.push(NOC.MATERIAL.V3.MATERIAL.TARGET_MEMBER);
          matrix = this.MATRIX_SINGLE;
        } else if (materials.some((v) => (v.id === NOC.MATERIAL.V3.MATERIAL_BETA.DIMENSION_GROUP.id))) {
          // グループ
          newMaterials.push(NOC.MATERIAL.V3.MATERIAL_BETA.DIMENSION_GROUP);
          matrix = this.MATRIX_SINGLE;
        } else if (materials.some((v) => (v.id === NOC.MATERIAL.V3.MATERIAL_BETA.DIMENSION_DEPARTMENT.id))) {
          // 部署
          newMaterials.push(NOC.MATERIAL.V3.MATERIAL_BETA.DIMENSION_DEPARTMENT);
          matrix = this.MATRIX_SINGLE;
        }
      } else {
        if (materials.some((v) => (v.id === NOC.MATERIAL.V3.MATERIAL.TARGET_MEMBER.id))) {
          // メンバー + 年～時毎
          newMaterials.push(NOC.MATERIAL.V3.MATERIAL_BETA.TARGET_MEMBER);
          matrix = this.MATRIX_SINGLE;
        } else if (materials.some((v) => (v.id === NOC.MATERIAL.V3.MATERIAL.DIMENSION_GROUP.id))) {
          // グループ + 年～時毎
          newMaterials.push(NOC.MATERIAL.V3.MATERIAL_BETA.DIMENSION_GROUP);
          matrix = this.MATRIX_SINGLE;
        } else if (materials.some((v) => (v.id === NOC.MATERIAL.V3.MATERIAL_BETA.DIMENSION_DEPARTMENT.id))) {
          // 部署 + 年～時毎
          newMaterials.push(NOC.MATERIAL.V3.MATERIAL_BETA.DIMENSION_DEPARTMENT);
          matrix = this.MATRIX_SINGLE;
        }
        // else if (materials.some((v) => (v.id === NOC.MATERIAL.V3.MATERIAL.DIMENSION_GROUP.id))) {
        //   if (materials.some((v) => (v.id === NOC.MATERIAL.V3.MATERIAL.DIMENSION_MEMBER.id))) {
        //     // 旧グラフのグループ + メンバー毎はMULTIなので複数人として処理
        //     // プルダウンでグループ単位にチェックONするためフラグ付与
        //     newMaterials.push(NOC.MATERIAL.V3.MATERIAL.FLAG_GROUP_MEMBER);
        //   } else {
        //     // 新グラフのグループ + 年～時毎はSINGLE
        //     newMaterials.push(NOC.MATERIAL.V3.MATERIAL_BETA.DIMENSION_GROUP);
        //     matrix = this.MATRIX_SINGLE;
        //   }
        // }
      }

      // 複数人・複数グループの場合
      // 年 -> メンバー毎・年
      // 月 -> メンバー毎・月
      // 日 -> メンバー毎・日
      // 時 -> 旧デザインに対応するもの無し
      if (!isInverse) {
        // view -> actual（表示 -> DB）
        const isTargetAll = materials.some((v) => (v.id === NOC.MATERIAL.V3.MATERIAL.TARGET_ALL.id));
        const isTargetGroup = materials.some((v) => (v.id === NOC.MATERIAL.V3.MATERIAL.TARGET_GROUP_MULTI.id));
        const isTargetDepartments = materials.some((v) => (v.id === NOC.MATERIAL.V3.MATERIAL_BETA.TARGET_DEPARTMENT_MULTI.id));
        if (isTargetAll) {
          // 旧グラフのフラグが設定されていれば適用
          if (materials.some((v) => (v.id === NOC.MATERIAL.V3.MATERIAL.FLAG_GROUP_MEMBER.id))) {
            newMaterials.push(NOC.MATERIAL.V3.MATERIAL.FLAG_GROUP_MEMBER);
          } else if (materials.some((v) => (v.id === NOC.MATERIAL.V3.MATERIAL.FLAG_MULTI_MEMBER.id))) {
            newMaterials.push(NOC.MATERIAL.V3.MATERIAL.FLAG_MULTI_MEMBER);
          }
          // 複数人・メンバー毎を追加
          newMaterials.push(NOC.MATERIAL.V3.MATERIAL.TARGET_ALL);
          newMaterials.push(NOC.MATERIAL.V3.MATERIAL.DIMENSION_MEMBER);
          matrix = this.MATRIX_MULTI;
        } else if (isTargetGroup) {
          // 複数グループ・メンバー毎を追加
          newMaterials.push(NOC.MATERIAL.V3.MATERIAL.TARGET_GROUP_MULTI);
          newMaterials.push(NOC.MATERIAL.V3.MATERIAL.DIMENSION_MEMBER);
          matrix = this.MATRIX_MULTI;
        } else if (isTargetDepartments) {
          // 複数部署・メンバー毎を追加
          newMaterials.push(NOC.MATERIAL.V3.MATERIAL_BETA.TARGET_DEPARTMENT_MULTI);
          newMaterials.push(NOC.MATERIAL.V3.MATERIAL.DIMENSION_MEMBER);
          matrix = this.MATRIX_MULTI;
        }
      } else {
        // actual -> view（DB -> 表示）
        const isTargetGroup = materials.some((v) => (v.id === NOC.MATERIAL.V3.MATERIAL.TARGET_GROUP_MULTI.id));
        const isTargetDepartments = materials.some((v) => (v.id === NOC.MATERIAL.V3.MATERIAL_BETA.TARGET_DEPARTMENT_MULTI.id));
        const isTargetAll = !isTargetGroup && !isTargetDepartments && materials.some((v) => (v.id === NOC.MATERIAL.V3.MATERIAL.DIMENSION_MEMBER.id));

        if (isTargetAll) { // 複数人
          if (!newMaterials.some((v) => v.id === NOC.MATERIAL.V3.MATERIAL.FLAG_GROUP_MEMBER.id) &&
            !materials.some((v) => v.id === NOC.MATERIAL.V3.MATERIAL.TARGET_ALL.id)) {
            // "メンバー毎"のみの場合は旧グラフの複数人表示なのでフラグ付与
            // （グループメンバー毎のフラグがついている場合を除く）
            newMaterials.push(NOC.MATERIAL.V3.MATERIAL.FLAG_MULTI_MEMBER);
          }
          newMaterials.push(NOC.MATERIAL.V3.MATERIAL.TARGET_ALL);
          matrix = this.MATRIX_MULTI;
        } else if (isTargetGroup) { // 複数グループ
          newMaterials.push(NOC.MATERIAL.V3.MATERIAL.TARGET_GROUP_MULTI);
          matrix = this.MATRIX_MULTI;
        } else if (isTargetDepartments) { // 複数部署
          newMaterials.push(NOC.MATERIAL.V3.MATERIAL_BETA.TARGET_DEPARTMENT_MULTI);
          matrix = this.MATRIX_MULTI;
        }
      }

      // 年毎、月毎、日毎、時毎
      if (matrix) {
        if (!isInverse) {
          for (const elem of matrix) {
            if (materials.some((v) => (v.id === elem.view.id))) {
              newMaterials = newMaterials.concat(elem.actual);
              break;
            }
          }
        } else {
          let isFound = false;
          findloop:
          for (const elem of matrix) {
            for (const act of elem.actual) {
              if (materials.some((v) => (v.id === act.id))) {
                newMaterials.push(elem.view);
                isFound = true;
                break findloop;
              }
            }
          }
          // actual->viewの場合はどれにも引っかからなかったら最後の条件を適用
          if (!isFound) {
            const lastElem = matrix[matrix.length - 1];
            if (lastElem.actual.length < 1) {
              newMaterials.push(lastElem.view);
            }
          }
        }
      }
      // console.log(newMaterials);
      return newMaterials;
    },
    // todo:型
    classGraphIcon(value: string) {
      let darken = false;

      const isMultiMembersOrGroups = () => (this.materialsView.some((v) =>
        v.id === NOC.MATERIAL.V3.MATERIAL.TARGET_ALL.id ||
        v.id === NOC.MATERIAL.V3.MATERIAL.TARGET_GROUP_MULTI.id ||
        v.id === NOC.MATERIAL.V3.MATERIAL_BETA.TARGET_DEPARTMENT_MULTI.id));
      const isSelectedMultiMeasures = () => NOC.MATERIAL.V3.getMeasures(this.materialsView).length > 1;
      const isSelectedCompareItems = () => (this.materialsView.some((v) =>
        v.domain === NOC.MATERIAL.V3.DOMAIN.COMPARE_TYPE ||
        v.domain === NOC.MATERIAL.V3.DOMAIN.COMPARE_TARGET ||
        v.domain === NOC.MATERIAL.V3.DOMAIN.COMPARE_MEASURE));
      const isSelectedMultiAxes = () => {
        const measures = NOC.MATERIAL.V3.getMeasures(this.materialsView);
        return measures.some((v) =>
          v.id === NOC.MATERIAL.V3.MATERIAL.MEASURE_COUNT.id ||
          v.id === NOC.MATERIAL.V3.MATERIAL.COMPARE_MEASURE_COUNT.id) &&
        measures.some((v) =>
          v.id !== NOC.MATERIAL.V3.MATERIAL.MEASURE_COUNT.id &&
          v.id !== NOC.MATERIAL.V3.MATERIAL.COMPARE_MEASURE_COUNT.id);
      };

      switch (value) {
        case NOC.CHARTS.DOUGHNUT:
          // 複数人/複数グループで複数データ選択時に円グラフを非活性にする
          darken = isMultiMembersOrGroups() && isSelectedMultiMeasures();
          break;
        case NOC.CHARTS.HORIZONTALBAR:
          // 比較グラフ項目選択時に横棒グラフを非活性にする
          darken = isSelectedCompareItems();
          break;
        case NOC.CHARTS.STACKED_BAR:
          // 異なる単位(ex. 時分, 回)のデータ同士を選択時、積み上げ棒グラフを非活性にする
          darken = isSelectedMultiAxes();
          break;
        case NOC.CHARTS.STACKED_HORIZONTALBAR:
          // 異なる単位(ex. 時分, 回)のデータ同士を選択時、積み上げ棒グラフを非活性にする
          darken = isSelectedMultiAxes();
          // 比較グラフ項目選択時に積上げ横棒グラフを非活性にする
          darken = darken || isSelectedCompareItems();
          break;
      }

      return {
        selected: value === this.selectGraphClass,
        darken,
      };
    },
    // グラフ登録
    async onClickRegistGraph() {
      this.isButtonDisabled = true;
      const formData = {
        title: this.editGadget.title,
        comment: this.editGadget.comment,
      };

      if (this.editGadget.title.length <= 0 || (validation.checkValues(formData, this.items) > 0)) {
        const titleMax = this.$data.items.filter((x: IVariableInput) => x.key === 'title')[0].max;
        const commentMax = this.$data.items.filter((x: IVariableInput) => x.key === 'comment')[0].max;
        if (this.$data.editGadget.comment.length > commentMax) {
          this.$emit('info', `コメントは${commentMax}文字以内で入力してください。`);
        }
        if (this.$data.editGadget.title.length > titleMax) {
          this.$emit('info', `タイトルは${titleMax}文字以内で入力してください。`);
        } else {
          this.$emit('info', '入力不備があります。');
        }
        this.isButtonDisabled = false;
        return;
      }
      // this.setGadgetData();
      this.editGadget.options = this.editOptions;
      const requestData: models.VGraphEdit = {
        gadget: this.editGadget,
        values: this.editValues,
      };
      // api start
      const api = new API();
      let res;
      if (this.editGadget.gadgetID === 0) {
        res = await api.post<models.VGraphEdit, any>('graph/new', requestData);
      } else {
        res = await api.put<models.VGraphEdit, any>('graph/edit', requestData);
      }
      // console.log(res);
      // result
      if (res.result) {
        // 通信して成功時に再設定
        this.gadgets = res.data.gadgets;

        if (this.editGadget.gadgetID === 0 && !this.addGadgetLock(0)) {
          // 新規追加
          this.isButtonDisabled = false;
          this.addDashboardConfirmModal = true;
          // if (await this.confirmDialog('今作成したグラフをダッシュボードに追加しますか？')) {
          //   // ダッシュボードに追加してダッシュボードに戻る
          //   this.$emit('newAdd', this.gadgets[this.gadgets.length - 1]);
          // } else {
          //   return; // ダッシュボードに追加せずそのままグラフ新規作成画面
          // }
        } else {
          // 変更
          // this.$emit('info', 'グラフを登録しました。');
          this.$emit('updateGadgets', res.data.gadgets);
        }
        // this.$emit('updateGadgets', res.data.gadgets);
      } else {
        // this.$emit('info', '登録できませんでした。');
        this.$emit('info', 'グラフの種類まで選択してください。');
        this.isButtonDisabled = false;
      }
    },
    addToDashboard() {
      // 今作成したグラフをダッシュボードに追加する
      this.addDashboardConfirmModal = false;
      this.$emit('newAdd', this.gadgets[this.gadgets.length - 1]);
      this.$emit('updateGadgets', this.gadgets);
    },
    backToAddGadgets() {
      // グラフ一覧に戻る
      this.addDashboardConfirmModal = false;
      this.$emit('updateGadgets', this.gadgets);
    },
    async onClickDelteGraph() {
      this.$emit('delete', this.editGadget.gadgetID);
    },
    showDetail(values: models.IValues) {
      // console.log('showDetail', values);
      this.editValues = values;
      this.detailModal = true;
    },
    returnSetting(key: string): any {
      return (this as any).frameData[key] ? (this as any).frameData[key] : false;
    },
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>);



